module.exports = __webpack_public_path__ + "static/img/semi.c6082bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/semi.png
// module id = 7/nZ
// module chunks = 1